import React from "react";
import {
  SocialButtonContainer,
  SocialIconWrapper,
  RightArrowIcon,
  SocialButtonWrapper,
  SocialIcon,
} from "./SocialButton.styles";
import { SocialButtonProps } from "./SocialButton.types";
import { Heading5SemiboldTypography } from "../../primitives/Typography/typographyVariants";

export const SocialButton = ({
  variant,
  onClick,
  children,
  disabled = false,
}: SocialButtonProps) => {
  const socialIcons = {
    instagram: "fa-kit fa-instagram",
    youtube: "fa-brands fa-youtube",
    facebook: "fa-brands fa-facebook",
    telegram: "fa-brands fa-telegram",
  };

  return (
    <SocialButtonWrapper>
      <SocialButtonContainer
        variant={variant}
        onClick={onClick}
        disabled={disabled}
      >
        <SocialIconWrapper>
          <SocialIcon className={socialIcons[variant]} />
        </SocialIconWrapper>
        <Heading5SemiboldTypography>{children}</Heading5SemiboldTypography>
        <RightArrowIcon className="fa-kit fa-btn-arrow" />
      </SocialButtonContainer>
    </SocialButtonWrapper>
  );
};
